import React from 'react';
import { CommentListEventItem } from './CommentListEventItem';
import { Trans } from '@lingui/react/macro';
import { faPencil } from '@fortawesome/pro-light-svg-icons';
import HistoryLogComparison, { ComparisonObject } from '@/seller/components/HistoryLog/HistoryLogComparison';
import { CommentMessage } from '@ygtechnologies/bygr-frontend-chat';

export interface CommentListEventChangeRequestEditedProps {
    comment: CommentMessage;
}

export const CommentListEventChangeRequestEdited: React.FC<CommentListEventChangeRequestEditedProps> = ({ comment }) => {
    var data: ComparisonObject[] = comment.data;
    return (
        <CommentListEventItem
            title={<Trans>Change request edited</Trans>}
            topText={''}
            bottomText={data.length > 0 && <HistoryLogComparison forceTable data={data} operationKey={'Edited'} />}
            icon={faPencil}
        />
    );
};
